import './Footer.scss';
import React from 'react';

const FooterComponent = () => {
  return (
    <>
      <footer className='Footer'>
        <div className='container'>
          <div className='links'>
            <a href='/impressum' target='_blank'>
              Impressum
            </a>
            <a href='/datenschutz' target='_blank'>
              Datenschutz
            </a>
          </div>
          <a href='https://www.ambion.de' target='_blank'>{`© AMBION GmbH ${new Date().getFullYear()}`}</a>
        </div>
      </footer>
    </>
  );
};

export default FooterComponent;
